import { IconButton } from "@mui/material";
import { PlusIcon, MinusIcon } from "@phosphor-icons/react";
import clsx from "clsx";

const buttonStyles = {
  border: "1px solid",
  borderColor: "var(--color-stroke-neutral-soft)",
  borderRadius: "9999",
  "&.Mui-disabled": {
    backgroundColor: "var(--color-surface-background)",
  },
};

interface CounterProps {
  value: number;
  step?: number;
  maxValue?: number;
  minValue?: number;
  plusButtonDisabled?: boolean;
  minusButtonDisabled?: boolean;
  onChange: (newValue: number) => void;
}

export function CounterButton({
  value,
  step = 1,
  maxValue,
  minValue = 0,
  plusButtonDisabled,
  minusButtonDisabled,
  onChange,
}: CounterProps) {
  const minusDisabled = minusButtonDisabled || value <= minValue;
  const plusDisabled =
    plusButtonDisabled || (maxValue != null && value >= maxValue);

  return (
    <div className="flex w-fit items-center gap-2 text-text-primary">
      <IconButton
        onClick={() => onChange(Math.max(value - step, minValue))}
        disabled={minusDisabled}
        type="button"
        aria-label="-"
        sx={buttonStyles}
      >
        <MinusIcon
          size={16}
          className={clsx({
            "text-text-primary": !minusDisabled,
            "text-disabled-primary": minusDisabled,
          })}
          weight="bold"
        />
      </IconButton>
      <span className="flex w-3 justify-center text-text-label">{value}</span>
      <IconButton
        onClick={() => {
          const newValue = value + step;
          onChange(maxValue != null ? Math.min(newValue, maxValue) : newValue);
        }}
        disabled={plusDisabled}
        type="button"
        aria-label="+"
        sx={buttonStyles}
      >
        <PlusIcon
          size={16}
          className={clsx({
            "text-text-primary": !plusDisabled,
            "text-disabled-primary": plusDisabled,
          })}
          weight="bold"
        />
      </IconButton>
    </div>
  );
}
